module.exports = __webpack_public_path__ + "h5/img/qrcode_for_subscribe.90a7e328.jpg";